import React, { useState } from "react";
import { GiCancel } from "react-icons/gi";
import { FiSave } from "react-icons/fi";
import { useNavigate, useLocation } from "react-router-dom";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../../HandleHttpErrors";

const baseURL = process.env.REACT_APP_API_JOBS;

const Edit = ({
  rltv,
  departmentsList,
  handleCancelClick,
  increment,
  counter,
  setRltvId,
  rltvOptions,
}) => {
  const [newRltv, setNewRltv] = useState(rltv);
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();
  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setNewRltv((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleDDSChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    const n = Number(value);

    setNewRltv((prevState) => ({
      ...prevState,
      [name]: n,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();
    const getData = async () => {
      try {
        const response = await axiosPrivate.put(
          baseURL + "relative/" + newRltv.id + "/",
          newRltv,
          {
            signal: controller.signal,
          }
        );
        if (isMounted) {
          increment();
          setRltvId(null);
        }
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };
    getData();
  };

  return (
    <tr>
      <td>
        <input
          type="text"
          name="full_name"
          className="form-control"
          id="full_name"
          value={newRltv.full_name}
          placeholder=""
          onChange={handleChange}
        />
      </td>
      <td>
        <input
          type="text"
          name="idz"
          className="form-control"
          id="idz"
          value={newRltv.idz}
          placeholder=""
          onChange={handleChange}
        />
      </td>
      <td>
        <select
          name="rltv_type"
          onChange={handleChange}
          value={newRltv.rltv_type}
        >
          <option key="0" value="" selected>
            בחר שפה
          </option>
          {rltvOptions?.map((a) => (
            <option key={a[0]} value={a[1]}>
              {a[1]}
            </option>
          ))}
        </select>
      </td>
      <td>
        <input
          type="text"
          name="job"
          className="form-control"
          id="job"
          value={newRltv.job}
          placeholder=""
          onChange={handleChange}
        />
      </td>
      <td>
        <select
          name="department"
          onChange={handleDDSChange}
          value={newRltv.department}
        >
          <option value="" selected>
            בחר מחלקה
          </option>
          {departmentsList?.map((a) => (
            <option key={a.id} value={a.id}>
              {a.title}
            </option>
          ))}
        </select>
      </td>

      <td>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleSubmit}
        >
          <FiSave />
        </button>
        <span> </span>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleCancelClick}
        >
          <GiCancel />
        </button>
      </td>
    </tr>
  );
};

export default Edit;
